import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            start_time: '',
            end_time: '',
            admin_name: ''
        }
    }
}

const mutations = {
    changeActionlogPage(state, val) {
        state.params = val
    }
}


export default {
    state,
    mutations
}